import { Navigate } from "react-router-dom";
import { useAuth } from "@/auth/AuthContext";

const ProtectedRoute = ({ children }) => {
  const { user } = useAuth();
  if (user === null) {
    return (
      <div className="min-h-[60vh] flex items-center justify-center">
        <div className="eyebrow text-[#5C6661]">Loading…</div>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  return children;
};

export default ProtectedRoute;
